import * as Sentry from '@sentry/react';

// Shared consent constants — also used by CookieConsent component
export const CONSENT_STORAGE_KEY = 'cookie_consent';
export const CONSENT_ACCEPTED = 'accepted';
export const CONSENT_DECLINED = 'declined';

// Sentry sampling config
const PROD_TRACE_SAMPLE_RATE = 0.1;
const DEV_TRACE_SAMPLE_RATE = 1.0;
const REPLAY_SESSION_SAMPLE_RATE = 0.1;
const REPLAY_ERROR_SAMPLE_RATE = 1.0;

let initialized = false;

/**
 * Initialize analytics (Sentry) only if user has accepted cookie consent.
 * Safe for SSR/test environments where window/localStorage may not exist.
 * Can be called multiple times — only initializes once.
 */
export function initAnalytics() {
  if (initialized) return;
  if (typeof window === 'undefined') return;

  try {
    const consent = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (consent !== CONSENT_ACCEPTED) return;

    const dsn = import.meta.env.VITE_SENTRY_DSN;
    if (!dsn) return;

    Sentry.init({
      dsn,
      environment: import.meta.env.MODE,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: import.meta.env.PROD ? PROD_TRACE_SAMPLE_RATE : DEV_TRACE_SAMPLE_RATE,
      replaysSessionSampleRate: REPLAY_SESSION_SAMPLE_RATE,
      replaysOnErrorSampleRate: REPLAY_ERROR_SAMPLE_RATE,
    });

    initialized = true;
  } catch {
    // localStorage unavailable (e.g., private browsing restrictions)
  }
}
